exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
exports.i(require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/utils.scss"), "");
// Module
exports.push([module.id, ".copy-selectable-2BbEGU1Ymwr{-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text}\n", ""]);
// Exports
exports.locals = {
	"selectable": "copy-selectable-2BbEGU1Ymwr " + require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/utils.scss").locals["off-screen"] + ""
};